// frontend/src/components/StepCarousel.js
import React, { useState, useEffect, useRef } from 'react';
import api from '../api';
import ImmersiveStepCard from './ImmersiveStepCard';
import { useI18n } from '../i18n';
import './StepCarousel.css';

const StepCarousel = ({ task, onClose, onTaskUpdate }) => {
  const { t } = useI18n();
  const [guide, setGuide] = useState(task.guide || []);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    setGuide(task.guide || []);
    // Check scroll after guide loads or task changes
    setTimeout(checkScroll, 100);
  }, [task.guide]);

  const checkScroll = () => {
    if (containerRef.current) {
      const { scrollLeft, scrollWidth, clientWidth } = containerRef.current;
      setCanScrollLeft(scrollLeft > 10);
      setCanScrollRight(scrollLeft + clientWidth < scrollWidth - 10);
    }
  };

  useEffect(() => {
    window.addEventListener('resize', checkScroll);
    return () => window.removeEventListener('resize', checkScroll);
  }, []);

  const handleStepUpdate = async (index, updatedStep) => {
    const newGuide = [...guide];
    newGuide[index] = updatedStep;
    setGuide(newGuide);

    try {
      // Persist immediately to DB
      const res = await api.put(`/tareas/${task.id}`, {
        guide: newGuide
      });
      if (res.data.ok) {
        onTaskUpdate(res.data.task);
      }
    } catch (err) {
      console.error("Error saving step update:", err);
    }
  };

  const scrollLeft = () => {
    if (containerRef.current) {
      containerRef.current.scrollBy({ left: -400, behavior: 'smooth' });
    }
  };

  const scrollRight = () => {
    if (containerRef.current) {
      containerRef.current.scrollBy({ left: 400, behavior: 'smooth' });
    }
  };

  return (
    <div className="step-carousel-overlay">
      <div className="carousel-header">
        <button className="btn-back-carousel" onClick={onClose} title={t('media.backToPlace')}>
          ← {t('common.back')}
        </button>
        <h2 className="carousel-task-title">{task.main_task}</h2>
      </div>

      <div className="carousel-main-wrapper">
        <button
          className={`nav-arrow left ${!canScrollLeft ? 'hidden' : ''}`}
          onClick={scrollLeft}
          aria-label={t('media.previous')}
        >
          ‹
        </button>

        <div className="carousel-container" ref={containerRef} onScroll={checkScroll}>
          {guide.length > 0 ? (
            guide.map((step, idx) => {
              const safeStep = typeof step === 'string' ? step : (step?.text ? step : { ...step, text: '' });
              return (
                <div key={idx} className="carousel-item">
                  <ImmersiveStepCard
                    step={safeStep}
                    index={idx}
                    taskId={task.id}
                    onUpdate={handleStepUpdate}
                  />
                </div>
              );
            })
          ) : (
            <div className="empty-guide-msg">
              <p>{t('media.noSteps')}</p>
            </div>
          )}
        </div>

        <button
          className={`nav-arrow right ${!canScrollRight ? 'hidden' : ''}`}
          onClick={scrollRight}
          aria-label={t('common.next')}
        >
          ›
        </button>
      </div>
    </div>
  );
};

export default StepCarousel;
